import { Outlet, createFileRoute } from '@tanstack/react-router'
import '@xyflow/react/dist/style.css'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/workbench',
)({
  component: () => <Outlet />,
  loader: () => ({ breadcrumbTitle: 'Workbench' }),
})
